import { TunnelStep } from '../model/tunnel-step-type';
import { Configurators2DComponent } from '../../configurators-2d/configurators-2d.component';
import { CONFIG_CONTEXT } from '../../../enum/config-context.enum';
import { BaseFundingComponent } from '../common/base-funding/base-funding.component';
import { BaseInstallationComponent } from '../common/base-installation/base-installation.component';
import { BaseValidationComponent } from '../common/base-validation/base-validation.component';
import { CarpentryConfigurationComponent } from '../../configurators-2d/carpentry/configuration/configuration.component';
import { CarpentryTunnelProductsComponent } from './carpentry-tunnel-products/carpentry-tunnel-products.component';
import { environment } from 'src/environments/environment';
import { TunnelDataState } from 'src/app/stores/tunnel/model/tunnel-data-state';
import { Configuration } from 'src/app/models/configurators-2d/applications/carpentry/configuration';
import { FidelityCardTypeEnum } from 'src/app/services/fidelity/fidelity';
import { MODAL } from 'src/app/services/modal.service';
import { isCarpentryProjectLocked } from 'src/app/services/helpers/carpentry-order-state.helper';

export const CARPENTRY_TUNNEL_STEPS: TunnelStep[] = [
  {
    component: Configurators2DComponent,
    context: CONFIG_CONTEXT.CARPENTRY,
  },
];

/** /!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\/!\
 * A partir d'ici, cela concerne les étapes du tunnel de la menuiserie V2
 */
function isQuotationRecordsEmpty(stateValue: TunnelDataState): boolean {
  const configuration = stateValue.configurationData.get(CONFIG_CONTEXT.CARPENTRY) as Configuration | undefined;
  return !configuration?.quotationRecords || configuration.quotationRecords.length === 0;
}

function hasCarpentryOrderSent(stateValue: TunnelDataState): boolean {
  const config = stateValue.configurationData?.get(CONFIG_CONTEXT.CARPENTRY) as Configuration;
  return isCarpentryProjectLocked(config);
}

export const CARPENTRY_TUNNEL_STEPS_V2: TunnelStep[] = [
  {
    component: CarpentryConfigurationComponent,
    context: CONFIG_CONTEXT.CARPENTRY,
    title: 'Conception',
    isDisabled: stateValue => hasCarpentryOrderSent(stateValue),
  },
  {
    component: CarpentryTunnelProductsComponent,
    context: CONFIG_CONTEXT.CARPENTRY,
    title: "Liste d'achat",
    hideProductList: true,
    canPrint: true, // Va imprimer la liste d'achat et non le PDF de récapitulatif
    hideDiscountAction: true,
    isDisabled: stateValue => {
      return isQuotationRecordsEmpty(stateValue);
    },
  },
  ...(!environment.installationSpecifics.carpentry.disableInstallation
    ? [
        {
          component: BaseInstallationComponent,
          context: CONFIG_CONTEXT.CARPENTRY,
          title: 'Pose',
          canPrint: false,
          readonlyProductList: true,
          hideProductList: true,
          skipCheckBomEmpty: true,
          hideDiscountAction: true,
          isDisabled: stateValue => {
            return isQuotationRecordsEmpty(stateValue);
          },
          placeholderImageSrc: 'assets/img/carpentry/installation.png',
        },
      ]
    : []),
  {
    component: BaseFundingComponent,
    context: CONFIG_CONTEXT.CARPENTRY,
    title: 'Financement',
    canPrint: false,
    readonlyProductList: false,
    hideProductList: true,
    skipCheckBomEmpty: true,
    hideDiscountAction: true,
    isDisabled: stateValue => {
      return isQuotationRecordsEmpty(stateValue);
    },
    placeholderImageSrc: 'assets/img/carpentry/funding.png',
  },
  {
    component: BaseValidationComponent,
    context: CONFIG_CONTEXT.CARPENTRY,
    title: 'Validation',
    canPrint: true,
    readonlyProductList: true,
    hideProductList: false,
    skipCheckBomEmpty: true,
    hideDiscountAction: true,
    displayAddProductButton: true,
    skipModalToOpen: (stateValue, featureSettings) => {
      return (
        !featureSettings.fidelity ||
        (stateValue.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.AUCUNE &&
          stateValue.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.AUCUNE0)
      );
    },
    isDisabled: (stateValue, featureSettings) => {
      return (
        (featureSettings.financement
          ? stateValue.currentPricing?.totalWithFunding === undefined ||
            stateValue.currentFunding?.downPayment === undefined
          : stateValue.currentPricing?.totalWithoutFunding === undefined) ||
        (featureSettings.pose &&
          stateValue.currentInstallation?.withInstallation !== false &&
          stateValue.currentInstallation?.more2Years === undefined) ||
        stateValue.fidelityLoading ||
        (featureSettings.financement && stateValue.fundingLoading) ||
        isQuotationRecordsEmpty(stateValue)
      );
    },
    placeholderImageSrc: 'assets/img/carpentry/validation.png',
  },
];
